import { Pipe, PipeTransform } from '@angular/core';
import { ApiService } from 'src/lib/services/api.service';

@Pipe({
  name: 'apiUrl'
})
export class ApiUrlPipe implements PipeTransform {

	constructor(private window: Window,
				private apiService: ApiService) { }

    transform(url: string): string {
		if(url) {
			const urlBuilder = new URL((/^api\//i.test(url) && url) || `api/${url}`, this.window.location.origin);
			urlBuilder.searchParams.append('token', this.apiService.token);
			return urlBuilder.toString();
		}
	}
}
